const { REACT_APP_API_BASE_URL } = process.env;

// GET All Services
export const getServices = (token, query = {}) =>
  new Promise((resolve, reject) => {
    const queryParams = new URLSearchParams({
      ...query,
    }).toString();
    const request = new Request(
      REACT_APP_API_BASE_URL + "/services?" + queryParams,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    );
    fetch(request)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });

// GET One Service
export const getService = (token, id) =>
  new Promise((resolve, reject) => {
    const request = new Request(REACT_APP_API_BASE_URL + "/services/" + id, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    });
    fetch(request)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });

// CREATE Service
export const createService = (token, service, doubleFactorCode) =>
  new Promise((resolve, reject) => {
    const request = new Request(REACT_APP_API_BASE_URL + "/services", {
      method: "POST",
      body: JSON.stringify({ service }),
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        "x-double-factor": doubleFactorCode,
      },
    });
    fetch(request)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });

// UPDATE Service
export const updateService = (token, id, service) =>
  new Promise((resolve, reject) => {
    const request = new Request(REACT_APP_API_BASE_URL + "/services/" + id, {
      method: "PUT",
      body: JSON.stringify({ service }),
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    });
    fetch(request)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });

// DELETE Service
export const deleteService = (token, id) =>
  new Promise((resolve, reject) => {
    const request = new Request(REACT_APP_API_BASE_URL + "/services/" + id, {
      method: "DELETE",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    });
    fetch(request)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });

// SEED Default Services
export const seedServices = (token, defaultConfig = {}) =>
  new Promise((resolve, reject) => {
    const request = new Request(REACT_APP_API_BASE_URL + "/services/seed", {
      method: "POST",
      body: JSON.stringify({ defaultConfig }),
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    });
    fetch(request)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });

// UPDATE Admin Emails (Mass Update)
export const updateServicesAdminEmails = (token, adminEmails) =>
  new Promise((resolve, reject) => {
    const request = new Request(
      REACT_APP_API_BASE_URL + "/services/admin-emails",
      {
        method: "PATCH",
        body: JSON.stringify({ adminEmails }),
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    );
    fetch(request)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });

// DISABLE All Notifications
export const disableAllServicesNotifications = (token) =>
  new Promise((resolve, reject) => {
    const request = new Request(
      REACT_APP_API_BASE_URL + "/services/notifications/disable-all",
      {
        method: "PATCH",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    );
    fetch(request)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });

// PATCH Scheduler Cron
export const updateServiceSchedulerCron = (token, id, cron, timezone) =>
  new Promise((resolve, reject) => {
    const request = new Request(
      REACT_APP_API_BASE_URL + "/services/" + id + "/scheduler/cron",
      {
        method: "PATCH",
        body: JSON.stringify({ cron, timezone }),
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    );
    fetch(request)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });

// GET Period Examples
export const getServicesPeriodExamples = (token) =>
  new Promise((resolve, reject) => {
    const request = new Request(
      REACT_APP_API_BASE_URL + "/services/period-examples",
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    );
    fetch(request)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });

// ============ PROJECT SERVICES ============

// GET Services for Project
export const getProjectServices = (token, projectId) =>
  new Promise((resolve, reject) => {
    const request = new Request(
      `${REACT_APP_API_BASE_URL}/projects/${projectId}/services`,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    );
    fetch(request)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });

// GET One Service for Project
export const getProjectService = (token, projectId, serviceId) =>
  new Promise((resolve, reject) => {
    const request = new Request(
      `${REACT_APP_API_BASE_URL}/projects/${projectId}/services/${serviceId}`,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    );
    fetch(request)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });

// CREATE Service for Project
export const createProjectService = (token, projectId, service) =>
  new Promise((resolve, reject) => {
    const request = new Request(
      `${REACT_APP_API_BASE_URL}/projects/${projectId}/services`,
      {
        method: "POST",
        body: JSON.stringify({ service }),
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    );
    fetch(request)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });

// UPDATE Service for Project
export const updateProjectService = (token, projectId, serviceId, service) =>
  new Promise((resolve, reject) => {
    const request = new Request(
      `${REACT_APP_API_BASE_URL}/projects/${projectId}/services/${serviceId}`,
      {
        method: "PUT",
        body: JSON.stringify({ service }),
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    );
    fetch(request)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });

// DELETE Service for Project
export const deleteProjectService = (token, projectId, serviceId) =>
  new Promise((resolve, reject) => {
    const request = new Request(
      `${REACT_APP_API_BASE_URL}/projects/${projectId}/services/${serviceId}`,
      {
        method: "DELETE",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    );
    fetch(request)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });

// Toggle Scheduler
export const toggleProjectServiceScheduler = (
  token,
  projectId,
  serviceId,
  enabled
) =>
  new Promise((resolve, reject) => {
    const request = new Request(
      `${REACT_APP_API_BASE_URL}/projects/${projectId}/services/${serviceId}/toggle-scheduler`,
      {
        method: "PATCH",
        body: JSON.stringify({ enabled }),
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    );
    fetch(request)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });

// Toggle Auto Approval
export const toggleProjectServiceAutoApproval = (
  token,
  projectId,
  serviceId,
  enabled
) =>
  new Promise((resolve, reject) => {
    const request = new Request(
      `${REACT_APP_API_BASE_URL}/projects/${projectId}/services/${serviceId}/toggle-auto-approval`,
      {
        method: "PATCH",
        body: JSON.stringify({ enabled }),
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    );
    fetch(request)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });

// Toggle Email Admin
export const toggleProjectServiceEmailAdmin = (
  token,
  projectId,
  serviceId,
  enabled
) =>
  new Promise((resolve, reject) => {
    const request = new Request(
      `${REACT_APP_API_BASE_URL}/projects/${projectId}/services/${serviceId}/toggle-email-admin`,
      {
        method: "PATCH",
        body: JSON.stringify({ enabled }),
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    );
    fetch(request)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });

// Toggle Email Associate
export const toggleProjectServiceEmailAssociate = (
  token,
  projectId,
  serviceId,
  enabled
) =>
  new Promise((resolve, reject) => {
    const request = new Request(
      `${REACT_APP_API_BASE_URL}/projects/${projectId}/services/${serviceId}/toggle-email-associate`,
      {
        method: "PATCH",
        body: JSON.stringify({ enabled }),
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    );
    fetch(request)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });

// Toggle Service Enabled
export const toggleProjectServiceEnabled = (
  token,
  projectId,
  serviceId,
  enabled
) =>
  new Promise((resolve, reject) => {
    const request = new Request(
      `${REACT_APP_API_BASE_URL}/projects/${projectId}/services/${serviceId}/toggle-enabled`,
      {
        method: "PATCH",
        body: JSON.stringify({ enabled }),
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    );
    fetch(request)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });

// Update Admin Emails for Service
export const updateProjectServiceAdminEmails = (
  token,
  projectId,
  serviceId,
  adminEmails
) =>
  new Promise((resolve, reject) => {
    const request = new Request(
      `${REACT_APP_API_BASE_URL}/projects/${projectId}/services/${serviceId}/admin-emails`,
      {
        method: "PUT",
        body: JSON.stringify({ adminEmails }),
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    );
    fetch(request)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
